export default store => {
  const channel = new BroadcastChannel('vuex-sync')
  let isCommittingFromChannel = false

  const syncedMutations = [
    'features/updateFeature',
    'healthPlans/setAllHealthPlans',
    'attendanceStore/setCertificate'
  ]

  store.subscribe(mutation => {
    if (!isCommittingFromChannel && syncedMutations.includes(mutation.type)) {
      // Tenta serializar o payload
      let safePayload
      try {
        safePayload = JSON.parse(JSON.stringify(mutation.payload))
      } catch (e) {
        // Payload não serializável, não envia
        return
      }
      channel.postMessage({
        type: 'MUTATION',
        mutation: {
          type: mutation.type,
          payload: safePayload
        }
      })
    }
  })

  channel.onmessage = event => {
    const { type, mutation } = event.data
    if (type === 'MUTATION') {
      isCommittingFromChannel = true
      store.commit(mutation.type, mutation.payload)
      isCommittingFromChannel = false
    }
  }
}
